import { useEffect, useState } from "react"
import { useAuthcontext } from './useAuthcontext'

//firebase imports
import { auth, db } from "../firebase/config"
import { signOut } from "firebase/auth"
import { updateDoc, doc } from "firebase/firestore"

export const useLogout = () => {
    const[isCancelled, setIsCancelled] = useState(false)
    const[error,setError] = useState(null)
    const[ispending, setIspending] = useState(false)
    const { dispatch, user } = useAuthcontext()
    const logout = async() => {
        setError(null)
        setIspending(true)

                //sign the user out
                try {
                    //update online status
                    const {uid} = user
                    const docRef = doc(db,'users',uid)
                    await updateDoc(docRef,{
                        online: false
                    })

                    await signOut(auth)

                    //dispatch logout action
                    dispatch({ type: 'LOGOUT'})
                    if (!isCancelled) {
                        setIspending(false)
                        setError(null)
                    }

                } catch (err) {
                    if (!isCancelled) {
                        console.log(err.message)
                        setError(err.message)
                        setIspending(false)
                    }
                }      
    }

    useEffect(() => {
        return () => setIsCancelled(true)
    },[])

    return{logout, error, ispending}
}